module.exports = __webpack_public_path__ + "img/rascrut-4.ec5bc6d8.jpg";